import React, { useEffect, useRef, useState } from "react";
import "./Requetes.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import QuillOptions from "Components/QuillOptions/QuillOptions";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import Modal from "Components/Modal/Modal";
import ListCard from "./ListCard/ListCard";
import NewsletterCard from "./NewsletterCard/NewsletterCard";
import { Divider } from "primereact/divider";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { CgClose } from "react-icons/cg";
import { fetchPostUp, useFetchGet } from "Services/api";
import {
  fillListOfContact,
  getCustomIconBis,
  getListOfContacts,
} from "Services/newsletterFunctions";
import ModalAddContacts from "./ModalAddContacts/ModalAddContacts";
import Loader from "Components/Loader/loader";
import { SelectButton } from "primereact/selectbutton";
import { updateRequests } from "Redux/Actions/requestsActions";
import { showError, showSuccess } from "Services/functions";

const Requetes = (props) => {
  const items = [
    { name: "Mes newsletters", value: 1 },
    { name: "Mes listes de contacts", value: 2 },
  ];
  const newsletterData = useFetchGet("/newsletters", props.auth.token);
  const listOfContactsData = useFetchGet("/list_of_contacts", props.auth.token);
  const [allNewsletters, setAllNewsletters] = useState(null);
  const [allListOfContacts, setAllListOfContacts] = useState(null);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleSave, setVisibleSave] = useState(false);
  const [bottomPart, setBottomPart] = useState(1);
  const [newTitle, setNewTitle] = useState("");
  const requetesRef = useRef(null);
  const [currentNewsletter, setCurrentNewsletter] = useState({
    title: "",
    contacts: null,
    object: "",
    content: "",
  });

  useEffect(() => {
    window.scroll({
      top: requetesRef.current.offsetTop + 64,
      behavior: "smooth",
    });
    return () => {
      props.handleRequests({
        etapesData: [],
        groupsData: [],
      });
    };
  }, []);

  useEffect(() => {
    newsletterData.loaded && setAllNewsletters(newsletterData.data);
    listOfContactsData.loaded && setAllListOfContacts(listOfContactsData.data);
  }, [newsletterData.loaded, listOfContactsData.loaded]);

  const createList = async () => {
    let data = fillListOfContact(currentNewsletter.contacts);

    if (!data) return;

    data.title = newTitle;
    data.saved = true;

    const response = await fetchPostUp("/list_of_contacts", data);
    if (response.error) {
      showError("Une erreur est survenue");
    } else {
      let tempArray = [...allListOfContacts];
      tempArray.push(response.data);
      setAllListOfContacts(tempArray);
      showSuccess("Votre liste de contacts a bien été créée");
    }
  };

  const createNewsletter = async (state) => {
    const editor = document.getElementsByClassName("ql-editor")[0].textContent;
    if (!currentNewsletter.title || !editor) {
      showError(
        !currentNewsletter.title
          ? "Le titre est manquant"
          : "La newsletter n'a aucun contenu"
      );
      return;
    }

    let data = {
      title: currentNewsletter.title,
      object: currentNewsletter.object,
      content: currentNewsletter.content,
    };

    let listOfContact = null;
    if (currentNewsletter.contacts) {
      listOfContact = fillListOfContact(currentNewsletter.contacts);
      if (listOfContact) {
        listOfContact.title = currentNewsletter.title;
        listOfContact.saved = false;
      }
    }

    // Création de la liste de contact associée à la newsletter
    let listOfContactResponse = null;
    if (listOfContact) {
      listOfContactResponse = await fetchPostUp(
        "/list_of_contacts",
        listOfContact
      );
    }

    if (listOfContactResponse.error) {
      showError("Une erreur est survenue");
      return;
    } else if (listOfContactResponse?.data?.id) {
      data.listOfContact = `/api/list_of_contacts/${listOfContactResponse.data.id}`;
      let tempArray = [...allListOfContacts];
      tempArray.push(listOfContactResponse.data);
      setAllListOfContacts(tempArray);
    }

    let url = null;
    if (state === "Publié") {
      url = "/newsletters/send_newsletter";
    } else {
      url = "/newsletters/save_as_draft";
    }

    // Création de la newsletter
    const response = await fetchPostUp(url, data);
    if (response.error) {
      showError("Une erreur est survenue");
    } else {
      let tempArray = [...allNewsletters];
      tempArray.push(response.data);
      setAllNewsletters(tempArray);
      showSuccess("Votre liste de contacts a bien été créée");
    }
  };

  const loadList = (list) => {
    setCurrentNewsletter({
      ...currentNewsletter,
      contacts: getListOfContacts(list),
    });
  };

  const loadNewsletter = (newsletter, listOfContacts) => {
    setCurrentNewsletter({
      title: newsletter.title,
      contacts: listOfContacts ? getListOfContacts(listOfContacts) : null,
      object: newsletter.object,
      content: newsletter.content,
    });
  };

  // useEffect(() => {
  //   console.log(currentNewsletter);
  // }, [currentNewsletter]);
  return (
    <div className="requetes__export" ref={requetesRef}>
      <h1 className="h1_trait_dessus">
        {props.items[props.activeIndex].label}
      </h1>
      {props.auth.isConnected && (
        <div className="requetes">
          {currentNewsletter.title === "" && (
            <Tooltip target=".requetes__input" />
          )}
          <div
            className="requetes__input"
            style={{
              border: currentNewsletter.title === "" ? "1px solid red" : "",
            }}
            data-pr-tooltip="Le titre est requis"
            data-pr-position="right"
          >
            <div className="requetes__start">
              <div className="requetes__start__entete">Titre* : </div>
              <InputText
                value={currentNewsletter.title}
                onChange={(e) =>
                  setCurrentNewsletter({
                    ...currentNewsletter,
                    title: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="requetes__input">
            <div className="requetes__start">
              <div className="requetes__start__entete">À : </div>
              <span className="requetes__start__members">
                {currentNewsletter.contacts?.map((member, index) => (
                  <span key={index} className="member__fullname">
                    <img
                      src={getCustomIconBis(currentNewsletter.contacts)}
                      alt=""
                      className="customIcon"
                      style={{ marginRight: "0.25rem" }}
                    />
                    <span className="member__label">{member.label}</span>
                    <CgClose
                      onClick={() => {
                        setCurrentNewsletter({
                          ...currentNewsletter,
                          contacts: currentNewsletter.contacts.filter(
                            (item) => item.id !== member.id
                          ),
                        });
                      }}
                    ></CgClose>
                  </span>
                ))}
              </span>
            </div>
            <div className="requetes__icons">
              <Tooltip target=".requetes__icons__icon" />
              <div
                className="requetes__icons__icon pi pi-plus"
                data-pr-tooltip="Ajouter des contacts"
                data-pr-position="bottom"
                onClick={() => setVisibleAdd(true)}
              ></div>
              <div
                className="requetes__icons__icon pi pi-download"
                data-pr-tooltip="Importer une liste de contacts"
                data-pr-position="bottom"
                onClick={() => setVisibleImport(true)}
              ></div>
              <div
                className="requetes__icons__icon pi pi-save"
                data-pr-tooltip="Sauvegarder la liste de contacts"
                data-pr-position="bottom"
                onClick={() => setVisibleSave(true)}
              ></div>
            </div>
          </div>
          <div className="requetes__input">
            <div className="requetes__start">
              <div className="requetes__start__entete">Objet : </div>
              <InputText
                value={currentNewsletter.object}
                onChange={(e) =>
                  setCurrentNewsletter({
                    ...currentNewsletter,
                    object: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <ReactQuill
            className="requetes__editor"
            theme="snow"
            modules={QuillOptions.modules}
            formats={QuillOptions.formats}
            rows={5}
            value={currentNewsletter.content}
            onChange={(e) => {
              if (e !== "<p><br></p>") {
                setCurrentNewsletter({
                  ...currentNewsletter,
                  content: e,
                });
              }
            }}
          />
          <div className="requetes__buttons">
            <BtnBleu
              btnTexte="Envoyer"
              btnAction={() => createNewsletter("Publié")}
            ></BtnBleu>
            <BtnBleu
              btnTexte="Enregistrer"
              btnAction={() => createNewsletter("Brouillon")}
            ></BtnBleu>
            <BtnBleu
              btnTexte="Effacer"
              btnAction={() =>
                setCurrentNewsletter({
                  title: "",
                  contacts: null,
                  object: "",
                  content: "",
                })
              }
            ></BtnBleu>
          </div>
          <Divider></Divider>
          <SelectButton
            value={bottomPart}
            onChange={(e) => setBottomPart(e.value)}
            optionLabel="name"
            options={items}
          ></SelectButton>
          {bottomPart === 1 &&
            (allNewsletters && allListOfContacts ? (
              <div className="mynewsletters">
                {allNewsletters.map((x, key) => (
                  <NewsletterCard
                    key={key}
                    data={x}
                    contacts={
                      x.listOfContact
                        ? allListOfContacts.find(
                            (list) => list.id === x.listOfContact.id
                          )
                        : null
                    }
                    loadNewsletter={(newsletter, listOfContact) =>
                      loadNewsletter(newsletter, listOfContact)
                    }
                    allNewsletters={allNewsletters}
                    setAllNewsletters={setAllNewsletters}
                  ></NewsletterCard>
                ))}
              </div>
            ) : (
              <Loader></Loader>
            ))}
          {bottomPart === 2 &&
            (allListOfContacts ? (
              <div className="mylists">
                {allListOfContacts
                  .filter((x) => x.saved)
                  .map((x, key) => (
                    <ListCard
                      key={key}
                      data={x}
                      loadList={(list) => loadList(list)}
                      allListOfContacts={allListOfContacts}
                      setAllListOfContacts={setAllListOfContacts}
                    ></ListCard>
                  ))}
              </div>
            ) : (
              <Loader></Loader>
            ))}
        </div>
      )}

      {visibleAdd && (
        <ModalAddContacts
          visible={visibleAdd}
          setVisible={setVisibleAdd}
          onValid={(list) => {
            setCurrentNewsletter({
              ...currentNewsletter,
              contacts: list,
            });
            setVisibleAdd(false);
          }}
          contacts={currentNewsletter.contacts}
        ></ModalAddContacts>
      )}
      {visibleImport && (
        <Modal
          visible={visibleImport}
          setVisible={setVisibleImport}
          header="Import une liste de contacts"
          className="modal loadList newsletters"
        >
          <div className="mylists">
            {allListOfContacts &&
              allListOfContacts
                .filter((x) => x.saved)
                .map((x, key) => (
                  <ListCard
                    key={key}
                    data={x}
                    loadList={(list) => {
                      setVisibleImport(false);
                      loadList(list);
                    }}
                    select
                  ></ListCard>
                ))}
          </div>
        </Modal>
      )}
      {visibleSave && (
        <Modal
          visible={visibleSave}
          setVisible={setVisibleSave}
          header="Sauvegarder une liste de contacts"
          className="modal createList newsletters"
        >
          <InputText
            placeholder="Titre de la liste"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <BtnBleu
            btnTexte="Save"
            btnAction={() => {
              setVisibleSave(false);
              newTitle !== "" && createList();
            }}
          ></BtnBleu>
        </Modal>
      )}
    </div>
  );
};

Requetes.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  handleRequests: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  handleRequests: (value) => {
    dispatch(updateRequests(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Requetes);
